import React from 'react';
import { Alert, Box } from '@mui/material';
import { colorPalette } from '@qualifio/ui-commons';
import { useTranslation } from 'react-i18next';
import { sidebarAlertStyle } from './sidebar-alert-style';
import { useAccounts } from '../../../../accounts/AccountsContext';
import { useProgram } from '../../../../loyalty/ProgramContext';

export function ReferralSidebarAlert() {
  const { t } = useTranslation();
  const { currentAccount } = useAccounts();
  const { programId } = useProgram();

  return (
    <Box sx={sidebarAlertStyle}>
      <Alert severity="info">
        {t('editor.referral.traits.link.description.part1')}
        <a
          href={`/accounts/${currentAccount.id}/programs/${programId}/referral`}
          target="_blank"
          rel="noreferrer"
          style={{ color: colorPalette.blue.main }}
        >
          {t('editor.referral.traits.link.description.part2')}
        </a>
        {t('editor.referral.traits.link.description.part3')}
      </Alert>
    </Box>
  );
}
